import { render, staticRenderFns } from "./SmallVideo.vue?vue&type=template&id=0c5575f1&scoped=true&"
import script from "./SmallVideo.vue?vue&type=script&lang=js&"
export * from "./SmallVideo.vue?vue&type=script&lang=js&"
import style0 from "./SmallVideo.vue?vue&type=style&index=0&id=0c5575f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5575f1",
  null
  
)

export default component.exports